import { AxiosRequestConfig } from 'axios';

import { apiRequest } from 'helpers';
import { ReviewedFullCandidateProps, TrancheProps } from 'types';

// 404: "Tranche not found."
// 404: "Candidate not found."
// 409: "Candidate already associated with a tranche."
export const addCandidateToTranche = (candidate_id: number) => {
  return apiRequest<ReviewedFullCandidateProps>({
    method: 'POST',
    path: `/v3/tranches/current/candidates/${candidate_id}`,
  });
};

export const removeCandidateFromTranche = (candidate_id: number) => {
  return apiRequest<ReviewedFullCandidateProps>({
    method: 'DELETE',
    path: `/v3/tranches/current/candidates/${candidate_id}`,
  });
};

export const fetchTranches = (config: AxiosRequestConfig) => {
  return apiRequest<Array<TrancheProps>>({
    method: 'GET',
    path: '/v3/tranches',
    ...config,
  });
};
export const fetchAbridgedTranches = (config: AxiosRequestConfig) => {
  return apiRequest<Array<TrancheProps>>({
    method: 'GET',
    path: '/v3/tranches/abridged',
    ...config,
  });
};
// 404: "That Tranche ID cannot be found"
// 417: "Tranche must be in Signature_Pending state to be sent."
// 417: "Tranche has no associated candidates."
export const sendTranche = (candidate_id: number) => {
  return apiRequest<TrancheProps>({
    method: 'POST',
    path: `/v3/tranches/${candidate_id}/send`,
  });
};

// 404: "Tranche not found."
// 417: "Tranche must be in ACTIVE state to transition to SIGNATURE_PENDING."
// 417: "Tranche has no associated candidates."
export const sendForSignatureTranche = (candidate_id: number) => {
  return apiRequest<TrancheProps>({
    method: 'POST',
    path: `/v3/tranches/${candidate_id}/signature_pending`,
  });
};

export const fetchTrancheLetter = (tranche_id: number) => {
  return apiRequest<ArrayBuffer>({
    method: 'GET',
    path: `/v3/tranches/${tranche_id}/letter`,
    responseType: 'arraybuffer',
    headers: {
      Accept: 'application/pdf',
      'Content-Type': 'application/pdf',
    },
  });
};

export const fetchTrancheData = (tranche_id: number) => {
  return apiRequest<ArrayBuffer>({
    method: 'GET',
    path: `/v3/tranches/${tranche_id}/data`,
    responseType: 'arraybuffer',
    headers: {
      Accept: 'application/x-zip-compressed',
      'Content-Type': 'application/x-zip-compressed',
    },
  });
};

export const signTranche = (candidate_id: number) => {
  return apiRequest<TrancheProps>({
    method: 'PATCH',
    path: `/v3/tranches/${candidate_id}/sign`,
  });
};
